import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { AdvisorCompany } from '../models/advisor-company.model';

export interface CreateAdvisorCompanyArg {
    name: string;
    wiringInstructions: string | null;
    footerText: string | null;
}

export const CreateAdvisorCompany = createAsyncThunk(
    'advisorCompanies/create',
    async (arg: CreateAdvisorCompanyArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        const response = await axios.post('api/marketplace/advisor-companies', {
            name: arg.name,
            wiringInstructions: arg.wiringInstructions,
            footerText: arg.footerText,
        });

        if (response.status !== 200) {
            const message =
                response?.response?.data?.title ??
                response?.response?.data?.detail ??
                'An error occurred while adding the advisor company.';
            createNotification(message, 'error');
            throw new Error('Failed to create advisor company');
        }

        createNotification('Advisor company added.', 'success');
        return response.data as AdvisorCompany;
    }
);
